import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: " ",
    },
  },
  scales: {
    x: {
      title: {
        display: false,
        text: "Month",
      },
      stacked: true,
    },
    y: {
      title: {
        display: false,
        text: "Value",
      },
      min: 0,
      max: 2200,
      ticks: {
        // forces step size to be 50 units
        stepSize: 2200,
      },
    },
  },
};

const labels = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
  "Jan",
  "Feb",
  "Mar",
];

export const data = {
  labels,
  datasets: [
    {
      label: "Dataset 1",
      data: [
        100, 500, 1000, 200, 300, 500, 600, 800, 2000, 800, 600, 500, 300, 200,
        100,
      ],
      borderColor: "rgb(166,168, 173, 1)",
      backgroundColor: "rgba(166,168, 173, 1)",
    },
    {
      label: "Dataset 2",
      data: [
        200, 700, 2000, 300, 900, 300, 900, 800, 2000, 600, 600, 800, 2200,
        2000, 1000,
      ],
      borderColor: "rgb(53, 162, 235)",
      backgroundColor: "rgba(53, 162, 235, 0.5)",
    },
  ],
};

export default function EventVolume() {
  return <Line options={options} data={data} />;
}

/*
Required Data format :
response = > {
  //Array String type format
  time : ['Jan', 'Feb', ......] , 
  // Array of Arrays , Number type format
  values : [ [1000, 2000, 3000, .....], [1000, 2000, 3000, .....]]

}
*/
